import React from 'react';
import swal from 'sweetalert';

import { withFirebase } from '../../components/Firebase';
import { Link } from 'react-router-dom';

import ModulePanel from '../../components/ModulePanel';
import I18n from '../../locales/i18n';

import View from './view';

class MyBrand extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.setParam = this.setParam.bind(this);
		this.handleLogoValidation = this.handleLogoValidation.bind(this);
	}

	setParam(data) {
		const { uid = '__', collection = 'users' } = this.props;

		if (collection === 'users') {
			this.props.currentUser.update(data);
		}

		return this.props.firebase.updateById(collection, uid, data);
	}

	handleLogoValidation(file, _success) {
		const self = this;
		var reader = new FileReader();

		reader.onload = function (e) {
			var img = new Image();
			img.onload = function () {
				if (this.width <= 500 && this.height <= 100) {
					_success();
				} else {
					swal(
						'',
						'La imagen debe tener un ancho máximo de 500 pixeles y un alto máximo de 100 pixeles',
						'error'
					);
					self.props.onRequestLoading(false);
				}
			};
			img.src = e.target.result;
		};

		reader.readAsDataURL(file);
	}

	handleFaviconValidation = (file, _success) => {
		const self = this;
		var reader = new FileReader();

		reader.onload = function (e) {
			var img = new Image();
			img.onload = function () {
				if (this.width <= 300 && this.height <= 300) {
					_success();
				} else {
					swal(
						'',
						'La imagen debe tener un ancho máximo de 300 pixeles y un alto máximo de 300 pixeles',
						'error'
					);
					self.props.onRequestLoading(false);
				}
			};
			img.src = e.target.result;
		};

		reader.readAsDataURL(file);
	};

	render() {
		const { onRequestLoading, folder, bd, alert = false } = this.props;

		return (
			<ModulePanel title={[I18n('MY_BRAND', 'TITLE')]}>
				{alert && (
					<div className="alert alert-warning">
						{I18n('MY_BRAND', 'ANY_CHANGE_WILL_BE')}{' '}
						<Link to="/brand">{I18n('MY_BRAND', 'GLOBAL_BRAND_SETUP')}</Link>
					</div>
				)}
				<View
					onRequestLoading={onRequestLoading}
					handleLogoValidation={this.handleLogoValidation}
					handleFaviconValidation={this.handleFaviconValidation}
					setParam={this.setParam}
					bdData={bd}
					folder={folder}
				/>
			</ModulePanel>
		);
	}
}

export default withFirebase(MyBrand);
